import { useCallback, useEffect, useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CreateIcon from '@mui/icons-material/Create';
import { useStyles } from '../language.style';
import { GetLanguage, DeleteLanguage } from "../../../DAL/Language/language";
import { enqueueSnackbar } from "notistack";

export const useLanguage = () => {
  const classes = useStyles();
  const [languageData, setlanguageData] = useState([]);
  const [languageCount, setlanguageCount] = useState(0);
  const [singleLanguage, setsingleLanguage] = useState('');
  const [open, setOpen] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [action, setAction] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const tableCells = [
    { id: 'name', title: 'Name' },
    { id: 'direction', title: 'Direction' },
    { id: 'actions', title: 'Action(s)' },
  ];
  const actionsIcons = [
    { icon: <DeleteOutlineOutlinedIcon className={classes.iconStyle} />, action: "delete" },
    { icon: <CreateIcon className={classes.iconStyle} />, action: "edit" },
  ];

  useEffect(() => {
    getLanguagesData(page, limit, search);
  }, [page, limit, search]);

  const getLanguagesData = useCallback(async(page, limit, search) => {
    setIsLoading(true)
    let data = {
      page: Math.max(page + 1, 1),
      limit: limit,
      value: search,
      key: "name",
    }
    const response = await GetLanguage(data);
        if (response.statusCode == 200) {
          setIsLoading(false);
          setlanguageData(response?.data?.rows);
          setlanguageCount(response?.data?.count);
    
        } else {
          setIsLoading(false);
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleDelete = useCallback(async(id) => {
    const response = await DeleteLanguage(id); 
        if (response.statusCode == 200) {
          getLanguagesData(page, limit, search)
        } else {
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleAdd = useCallback(() => {
    setAction('add');
    setOpen(true);
  }, []);

  const handleActionClick = useCallback((index, row) => {
    setsingleLanguage(row);
    // dispatch(getsingleLanguageOrderData(row));
    if (index === 0) {
      setAction('delete');
      handleDelete(row.id);
    }
    if (index === 1) {
      setAction('update');
      setOpen(true);
    }
  }, []);

  const handleChangePage = useCallback((isTrue, newPage) => {
    if (isTrue) {
      setPage(newPage - 1);
    } else {
      setPage(newPage);
    }
  }, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const calculatePagesCount = (pageSize, totalCount) => {
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  const handleLanguageSearch = useCallback(value => {
    setSearch(value);
    setPage(0);
    setLimit(10);
  }, []);
  const handleGetLanguageData = useCallback(value => {
    getLanguagesData(page, limit, search)
  }, []);

  

  return {
    languageData,
    languageCount,
    singleLanguage,
    open,
    orderModal,
    action,
    tableCells,
    actionsIcons,
    page,
    limit,
    isLoading,
    setOpen,
    setOrderModal,
    handleGetLanguageData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleLanguageSearch,
  };
};
